'use client';

import { useId, useEffect } from 'react';
import clsx from 'classnames';

import { Portal } from '../portal';
import { useScrollBlock } from '../../../hooks';

import styles from './Modal.module.scss';
import { ModalProps } from './types';

let openedModalsWithBlockedScroll = 0;

export function Modal({
	backdropClassName,
	children,
	id,
	isOpen,
	wrapperClassName,
	onOverlayPress,
}: ModalProps) {
	const modalId = `${id || 'modal'}-${useId()}`;
	const [blockScroll, allowScroll] = useScrollBlock();

	useEffect(() => {
		function handleEscapeKey(event: KeyboardEvent) {
			if (event.code !== 'Escape') {
				return;
			}

			onOverlayPress?.();
		}

		if (isOpen) {
			++openedModalsWithBlockedScroll;
			document.addEventListener('keydown', handleEscapeKey);
			blockScroll();
		} else {
			openedModalsWithBlockedScroll =
				openedModalsWithBlockedScroll === 0 ? 0 : openedModalsWithBlockedScroll - 1;
			openedModalsWithBlockedScroll === 0 && allowScroll();
			document.removeEventListener('keydown', handleEscapeKey);
		}
		return () => {
			document.removeEventListener('keydown', handleEscapeKey);
		};
	}, [isOpen]);

	const backdropClasses = clsx(styles.modal__backdrop, {
		[styles['modal__backdrop--show']]: isOpen,
		backdropClassName,
	});
	const wrapperClasses = clsx(styles.modal__wrapper, wrapperClassName);

	const onOverlayClick = () => {
		onOverlayPress?.();
	};

	return (
		<Portal>
			<div id={modalId} className={backdropClasses} onClick={onOverlayClick}>
				<div onClick={(e) => e.stopPropagation()} className={wrapperClasses}>
					{children}
				</div>
			</div>
		</Portal>
	);
}
